import { gql } from '@apollo/client';
import { orderFragmentsWithBos } from 'next-common';
import { createServiceContractMutation as createDarsContract } from 'sales-common';

export const createServiceContractMutation = gql`
  mutation createServiceContract($orderId: ID!, $input: [InitialServiceContractInput!]!) {
    createServiceContract(orderId: $orderId, input: $input) {
      ...order
    }
  }
  ${orderFragmentsWithBos}
`;

export const updateServiceContractMutation = gql`
  mutation updateServiceContract($orderId: ID!, $input: [UpdateServiceContractInput!]!) {
    updateServiceContract(orderId: $orderId, input: $input) {
      ...order
    }
  }
  ${orderFragmentsWithBos}
`;

export const darsCreateContractMutation = gql`
  ${createDarsContract}
`;

export const removeServiceContractMutation = gql`
  mutation removeServiceContract($orderId: ID!, $id: String!) {
    removeServiceContract(orderId: $orderId, id: $id) {
      ...order
    }
  }
  ${orderFragmentsWithBos}
`;

export const uploadNBFPdfBufferMutation = `
  mutation uploadNBFPdfBuffer($fileBufferBase64: String!, $fileName: String!, $orderId: String!) {
    uploadNBFPdfBuffer(
      fileBufferBase64: $fileBufferBase64,
      fileName: $fileName,
      orderId: $orderId
    ) {
      status
      url
      fileName
      orderId
    }
  }
`;
